import React, { useEffect, useState } from "react";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../../assets/icons/close.png";
import itemImg from "./../../../../assets/icons/menu.png";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import { ToastContainer, toast } from "react-toastify";

import axios from "axios";

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

function MenuUnlinkModal(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =
    useState(false);
  const [openDeleteConfirmaitonModal, setopenDeleteConfirmaitonModal] =
    useState(false);
  const [openUnlinkConfirmaitonModal, setopenUnlinkConfirmaitonModal] =
    useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const columns = [
    {
      field: "RestaurantName",
      headerName: "Restaurant Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "MenuName",
      headerName: "Menu Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const {
    open,
    onClose,
    dialogType,
    id,
    cancledRes,
    cancleMenus,
    linkdata,
    onToggleSwitch,
    selectedRestaurants,
    openDialog: toggle,
    linkedFoodItems,
    linkedFooditem,
    Status,
    linkedMenu,
  } = props;

  console.log(id);
  console.log(cancledRes);
  console.log(linkedMenu);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);

  const handleClose = () => {
    props.onClose();
    //props.onHandleAddItem(restaurantId);
    // setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
  };

  useEffect(() => {
    loadData();
    //linkedMenuId
    console.log(linkedMenu);
    //loadData()
  }, [linkedMenu]);

  const loadData = () => {
    let list = [];
    linkedMenu?.map((dt, i) => {
      list.push(dt);
    });

    console.log(list);

    axios({
      method: "get",
      url:
        apiAddress +
        "/api/Menu/GetLinkedMenuInfoByMenuID?menuId=" +
        list[0]?.linkedMenuId,
    })
      .then((response) => {
        console.log(response);
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            linkedMenuId: dt.linkedMenuId,
            linkedRestaurantId: dt.linkedRestaurantId,
            RestaurantName: dt.linkedRestaurantName,
            MenuName: dt.linkedMenuName,
          };
          list.push(obj);
        });
        setDataRows(list);
      })
      .catch((error) => {});
  };

  const unlinkSubmit = () => {
    console.log(selectedDataRows);

    if (selectedDataRows.length == 0) {
      toast.error("Please select a Food Item!!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      console.log(selectedDataRows);
      var list = [];
      selectedDataRows.forEach((id) => {
        console.log(id);
        var obj = dataRows.find((x) => x.id === id);
        if (obj) {
          list.push(obj);
          console.log(list);
          if (list && list.length > 0) {
            let menuIds = [];
            let linkedMenuIds = [];
            linkedMenu.forEach((dt) => {
              menuIds.push(dt.linkedMenuId);
            });

            list.forEach((dt) => {
              linkedMenuIds.push(dt.linkedMenuId);
            });

            const data = {
              menuIds: menuIds,
              linkedMenuIds: linkedMenuIds,
            };
            console.log(data);

            var url = apiAddress + "/api/Menu/UnlinkMenu";

            axios.put(url, data).then((response) => {
              console.log(response.data);
              toast.success("Menu Succesfully Unlinked", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
              //console.log(canceledObjs)
              //props.onHandleAddItem(canceledObjs);
              setSelectedValue(null);
              setopenMenuCloseConfirmaitonModal(false);
              setopenUnlinkConfirmaitonModal(false);
              setOpenDialog(false);
              props.onClose();
            });
          }
        }
      });
    }
  };
  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"md"}
          fullWidth={true}
          open={props.open}
          onClose={handleClose}
        >
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={
              <>
                {/* Selected Menu will be unlinked from <strong>{linkedMenu[0]?.title}</strong> */}
              </>
            }
            open={openUnlinkConfirmaitonModal}
            onyes={unlinkSubmit}
            close={() => {
              setopenUnlinkConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={9}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={3}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent>
            <CustomDataGrid
              columns={columns}
              dataRows={dataRows}
              getselectedData={getselectedData}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenUnlinkConfirmaitonModal(true)}
              color="error"
            >
              Unlink
            </Button>
            <Button
              onClick={() => setopenMenuCloseConfirmaitonModal(true)}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default MenuUnlinkModal;
